// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import { DynamicProductFragmentDoc } from '../fragments/DynamicProduct.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type RecentlyViewedProductsQueryVariables = Types.Exact<{
  brand: Types.Scalars['String']['input'];
  productKey: Types.Scalars['String']['input'];
  dispType: Types.AnalyticsDispType;
  erpType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RecentlyViewedProductsQuery = { __typename?: 'Query', getRecentlyViewedProducts?: { __typename?: 'AssociatedProducts', products: Array<{ __typename?: 'Product', id?: string | null, productKey: string, productNumber: string, productSku?: string | null, lastBoughtUnix?: string | null, name: string, description?: string | null, gaProductCode?: string | null, isMarketplace: boolean, erp_type?: Array<string> | null, tags?: string | null, discount?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null }, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, mediumUrl: string }> }> } | null };


export const RecentlyViewedProductsDocument = gql`
    query RecentlyViewedProducts($brand: String!, $productKey: String!, $dispType: AnalyticsDispType!, $erpType: String) {
  getRecentlyViewedProducts(
    input: {brand: $brand, productKey: $productKey, dispType: $dispType, erpType: $erpType}
  ) {
    products {
      ...DynamicProduct
    }
  }
}
    ${DynamicProductFragmentDoc}`;
export type RecentlyViewedProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>, 'query'> & ({ variables: RecentlyViewedProductsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecentlyViewedProductsComponent = (props: RecentlyViewedProductsComponentProps) => (
      <ApolloReactComponents.Query<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables> query={RecentlyViewedProductsDocument} {...props} />
    );
    

/**
 * __useRecentlyViewedProductsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedProductsQuery({
 *   variables: {
 *      brand: // value for 'brand'
 *      productKey: // value for 'productKey'
 *      dispType: // value for 'dispType'
 *      erpType: // value for 'erpType'
 *   },
 * });
 */
export function useRecentlyViewedProductsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables> & ({ variables: RecentlyViewedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
      }
export function useRecentlyViewedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
        }
export function useRecentlyViewedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>(RecentlyViewedProductsDocument, options);
        }
export type RecentlyViewedProductsQueryHookResult = ReturnType<typeof useRecentlyViewedProductsQuery>;
export type RecentlyViewedProductsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedProductsLazyQuery>;
export type RecentlyViewedProductsSuspenseQueryHookResult = ReturnType<typeof useRecentlyViewedProductsSuspenseQuery>;
export type RecentlyViewedProductsQueryResult = Apollo.QueryResult<RecentlyViewedProductsQuery, RecentlyViewedProductsQueryVariables>;